import { render, staticRenderFns } from "./AccountGold.vue?vue&type=template&id=0a9ce558&scoped=true"
import script from "./AccountGold.vue?vue&type=script&lang=js"
export * from "./AccountGold.vue?vue&type=script&lang=js"
import style0 from "./AccountGold.vue?vue&type=style&index=0&id=0a9ce558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ce558",
  null
  
)

export default component.exports